module.exports = __webpack_public_path__ + "img/pica-text.3969db5a.svg";